export const AdDisplayMode = {
	_PERMAMENT:   'permanent',
	_10S_ONCE:    '10s_once',
	_10S_EACH_5M: '10s_each_5m',
	_CUSTOM:      'custom',
};
